import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../styles/formularios.css';
import '../styles/styles.css';
import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png.jpg';
import { Link } from 'react-router-dom';
const ConsultarDirectora = () => {
  return (
    <div className="container py-4 px-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Consultar Directora</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      {/* Formulario de solo lectura */}
      <div className="p-4 bg-light rounded shadow-sm">
        <form className="row g-3">

          <div className="col-md-3">
            <label className="form-label">ID Directora</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-3">
            <label className="form-label">ID Usuario</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-6">
            <label className="form-label">Nombre</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-3">
            <label className="form-label">Apellido Paterno</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-3">
            <label className="form-label">Apellido Materno</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-2">
            <label className="form-label">Sexo</label>
            <select className="form-select" disabled>
              <option>Femenino</option>
              <option>Masculino</option>
              <option>Otro</option>
            </select>
          </div>

          <div className="col-md-4">
            <label className="form-label">Teléfono</label>
            <input type="text" className="form-control" readOnly />
          </div>

          <div className="col-md-6">
            <label className="form-label">Correo</label>
            <input type="email" className="form-control" readOnly />
          </div>

          <div className="col-md-6">
            <label className="form-label">Fecha de Nacimiento</label>
            <input type="date" className="form-control" readOnly />
          </div>

          <div className="col-md-6">
            <label className="form-label">Puesto</label>
            <input type="text" className="form-control" readOnly />
          </div>

          {/* Botón Salir */}
          <div className="d-flex justify-content-center gap-3 mt-4">
              <Link to="/directora/inicio" className="btn btn-danger px-4">Salir</Link>
          </div>
        </form>
      </div>

      
    </div>
  );
};

export default ConsultarDirectora;
